/**
 * Download data to computer.
 *
 * @author Ihar Kazlouski
 * @param {string} data data.
 * @return {void}
 */
var exportData = function exportData(data, name) {
  var text = "data:text/json;charset=utf-8,".concat(encodeURIComponent(data || ''));
  var link = document.createElement('a');
  link.href = text;
  link.download = "".concat(name, ".json");
  link.click();
};

export { exportData };